module.exports = __webpack_public_path__ + "img/tt-4.70c0d452.png";